import { render, staticRenderFns } from "./WorkspaceFabricPreAdditionalElementsTool.vue?vue&type=template&id=6f11026a&scoped=true&"
import script from "./WorkspaceFabricPreAdditionalElementsTool.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFabricPreAdditionalElementsTool.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceFabricPreAdditionalElementsTool.vue?vue&type=style&index=0&id=6f11026a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f11026a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f11026a')) {
      api.createRecord('6f11026a', component.options)
    } else {
      api.reload('6f11026a', component.options)
    }
    module.hot.accept("./WorkspaceFabricPreAdditionalElementsTool.vue?vue&type=template&id=6f11026a&scoped=true&", function () {
      api.rerender('6f11026a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceFabricPreAdditionalElementsTool.vue"
export default component.exports